<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="交易时间">
      <!-- <el-date-picker
        v-model="dateRange"
        type="daterange"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        :disabled-date="disabledDate"
        @blur="handleDateChange"
      /> -->
      <el-date-picker
        v-model="dateStartRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="开始时间"
        :disabled-date="disabledDate"
        @change="handleDateStartChange"
      />
      <el-date-picker
        v-model="dateEndRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateEndChange"
      />
    </el-form-item>
    <el-form-item label="平台订单号">
      <el-input
        v-model="queryParam.platformnum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('platformnum', { unique: true })"
      />
    </el-form-item>
    <el-form-item label="垚旌订单号">
      <el-input
        v-model="queryParam.ordernum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('ordernum', { unique: true })"
      />
    </el-form-item>
    <!-- <el-form-item label="垚旌父订单号">
      <el-input
        v-model="queryParam.pordernum"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
      />
    </el-form-item> -->
    <el-form-item label="礼包商品名称">
      <el-input v-model.trim="queryParam.pname" placeholder="礼包商品名称" />
    </el-form-item>
    <el-form-item label="商品名称">
      <el-input v-model.trim="queryParam.name" placeholder="输入商品名称" />
    </el-form-item>
    <el-form-item label="商品ID">
      <el-input v-model.trim="queryParam.goodsnum" placeholder="输入商品ID" />
    </el-form-item>
    <el-form-item label="订单标识">
      <el-select
        v-model="queryParam.orderidentifier"
        filterable
        placeholder="选择订单标识"
      >
        <template v-for="item in orderIdentifierData" :key="item.identifierid">
          <el-option :label="item.identifiername" :value="item.identifiername" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="异常订单状态">
      <el-select v-model="queryParam.abnormalstatus" placeholder="选择异常订单状态">
        <el-option label="未处理" :value="1" />
        <el-option label="跟进中" :value="2" />
      </el-select>
    </el-form-item>
    
    <el-form-item label="客户">
      <el-select
        v-model="queryParam.customerid"
        multiple
        filterable
        placeholder="选择客户"
      >
        <template v-for="item in customerData" :key="item.customerid">
          <el-option :label="item.name" :value="item.customerid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="供应商">
      <el-select
        v-model="queryParam.supplierid"
        multiple
        filterable
        placeholder="选择供应商"
      >
        <template v-for="item in supplierData" :key="item.supplierid">
          <el-option :label="item.name" :value="item.supplierid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="快递单号">
      <el-input v-model.trim="queryParam.expressnum" placeholder="输入快递单号" />
    </el-form-item>
    <el-form-item label="收货人姓名">
      <el-input v-model="queryParam.receiver" type="textarea" placeholder="多个使用回车分割" autosize @blur="autoFormat('receiver', { unique: true })" />
    </el-form-item>
    <el-form-item label="收货人电话">
      <el-input
        v-model="queryParam.receiverphone"
        type="textarea"
        placeholder="多个使用回车分割"
        autosize
        @blur="autoFormat('receiverphone', { unique: true })"
      />
    </el-form-item>
    <el-form-item label="订单状态">
      <el-select v-model="queryParam.orderstatus" placeholder="选择订单状态">
        <!-- 待发货、备货中、发货失败、已发货、发货完结、已取消 -->
        <!-- <el-option label="备货中" :value="1" />
        <el-option label="发货失败" :value="2" />
        <el-option label="发货完成" :value="3" />
        <el-option label="已取消" :value="4" /> -->
        <el-option label="待发货" :value="1" />
        <el-option label="备货中" :value="2" />
        <el-option label="发货失败" :value="3" />
        <el-option label="已发货" :value="4" />
        <el-option label="发货完结" :value="5" />
        <el-option label="已取消" :value="6" />
      </el-select>
    </el-form-item>
    <el-form-item label="毛利率状态">
      <el-select v-model="queryParam.maolivstatus" placeholder="选择毛利率状态">
        <el-option label="正常" :value="1" />
        <el-option label="异常" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListOrder">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <!-- <el-button
          type="danger"
          @click="(dialog = true), doOrderAdd()"
          v-hasPermission="['order:add']"
          >新增备货中订单</el-button
        > -->
        
        <el-button
          type="danger"
          @click="openImport('order:import')"
          v-hasPermission="['order:import']"
          >导入待发货订单</el-button
        >
        <el-button
          type="danger"
          @click="openImport('order:importexpress')"
          v-hasPermission="['order:importexpress']"
          >导入快递单号</el-button
        >
        <el-button
          type="danger"
          @click="openImport('order:importprice')"
          v-hasPermission="['order:importprice']"
          >导入订单销售价</el-button
        >
        <el-button type="primary" v-hasPermission="['order:export']" @click="doExportPageOrder('supplier')" :loading="loadingsupplier">{{
          loadingsupplier ? "处理中 ..." : "按供应商（发货模版）导出"
        }}<el-tooltip content="一次最多导出5万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button>

        <el-button type="warning" v-hasPermission="['order:express:export']" @click="doExportPageOrder('express')" :loading="loadingexpress">{{
          loadingexpress ? "处理中 ..." : "按快递单号导出"
        }}<el-tooltip content="一次最多导出5万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button>
        <el-button
          type="primary"
          @click="openImport('order:identifier')"
          v-hasPermission="['order:identifier']"
          >订单标识</el-button>
        <el-button
          type="success"
          @click="showExportOrderDialog"
          v-hasPermission="['order:export']"
          >导出订单<el-tooltip content="一次最多导出5万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button
        >
      </div>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-tabs class="tabs-log" v-model="activeTabName" @tab-click="doTabClick">
        <!-- 待发货、备货中、发货失败、已发货、发货完结、已取消 -->
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待发货" name="wait">
          <template #label>
            <span class="custom-tabs-label">
              <span>待发货</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderTitle[0]}}</el-link>
            </span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="pending">
          <template #label>
            <span class="custom-tabs-label">
              <span>备货中</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderTitle[1]}}</el-link>
            </span>
          </template>
          <div class="waitTab">
          <el-badge :value="countOrderPending[0]" :max="99" class="item">
            <el-button @click="getPendingOrder(24)">24小时未发货</el-button>
          </el-badge>
          <el-badge :value="countOrderPending[1]" :max="99" class="item">
            <el-button @click="getPendingOrder(36)">36小时未发货</el-button>
          </el-badge>
          <el-badge :value="countOrderPending[2]" :max="99" class="item">
            <el-button @click="getPendingOrder(48)">48小时未发货</el-button>
          </el-badge>
          <el-badge :value="countOrderPending[3]" :max="99" class="item">
            <el-button @click="getPendingOrder(72)">72小时未发货</el-button>
          </el-badge>
          <el-badge :value="countOrderPending[4]" :max="99" class="item">
            <el-button @click="getPendingOrder(72000)">72小时以上未发货</el-button>
          </el-badge>
          </div>
        </el-tab-pane>
        <el-tab-pane label="发货失败" name="fail">
          <template #label>
            <span class="custom-tabs-label">
              <span>发货失败</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderTitle[2]}}</el-link>
            </span>
          </template>
        </el-tab-pane>
        <el-tab-pane label="已发货" name="success">
          <template #label>
            <span class="custom-tabs-label">
              <span>已发货</span>
              <el-link type="danger" style="margin-left:10px">{{countOrderTitle[3]}}</el-link>
            </span>
          </template>
        </el-tab-pane>
        <el-tab-pane label="发货完结" name="completed"></el-tab-pane>
        <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        @selection-change="doSelectionOrder"
        v-loading="loadingData"
        class="mainTable"
        row-key="orderid"
        height="600"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="平台交易时间" prop="platformed" width="155">
          <template #default="scope">
            <span v-text="util.formatDateUnix(scope.row.platformed, 'yyyy-MM-dd hh:mm')"></span>
          </template>
        </el-table-column>
        <el-table-column label="客户" prop="customer.name" width="200" />
        <el-table-column label="平台订单号" prop="platformnum" width="250" />
        <el-table-column label="垚旌订单号" prop="ordernum" width="250" />
        <!-- <el-table-column label="父垚旌订单号" prop="pordernum" width="220" /> -->
        <!-- <el-table-column label="订单类型" prop="ordertype">
          <template #default="scope">
          <template v-if="scope.row.ordertype==1">
              <el-tag
              round
              disable-transitions
              ><span
                v-text="util.showOrderType(scope.row.ordertype)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.ordertype==2">
              <el-tag
              round
              type="danger"
              disable-transitions
              ><span
                v-text="util.showOrderType(scope.row.ordertype)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.ordertype==3">
              <el-tag
              round
              type="warning"
              disable-transitions
              ><span
                v-text="util.showOrderType(scope.row.ordertype)"
              ></span>
              </el-tag>
            </template>
            </template>
        </el-table-column> -->
        <el-table-column label="商品名称" prop="name" width="300" />
        <el-table-column label="成本金额" align="center" prop="costamount">
          <template #default="scope">
            <span v-if="scope.row.costamount" v-text="(scope.row.costamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="毛利率" align="center" prop="maoliv" width="120">
          <template #default="scope">
            <span v-if="scope.row.maoliv" v-text="(scope.row.maoliv*100).toFixed(2) + '%'" />
            <el-tag
              round
              :type="scope.row.maolivstatus === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span
                v-text="util.showOrderMaoliv(scope.row.maolivstatus)"
              ></span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="销售金额" align="center" prop="saleamount">
          <template #default="scope">
            <span v-if="scope.row.saleamount" v-text="(scope.row.saleamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="供应商" align="center" prop="supplier.name" width="200" />
        <el-table-column label="订单状态" align="center" prop="orderstatus">
          <template #default="scope">
            <!-- 待发货、备货中、发货失败、已发货、发货完结、已取消 -->
            <template v-if="scope.row.orderstatus==1">
              <el-tag
              round
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==2">
              <el-tag
              round
              type="danger"
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==3">
              <el-tag
              round
              type="warning"
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==4">
              <el-tag
              round
              type="success"
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==5">
              <el-tag
              round
              type="success"
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
            <template v-else-if="scope.row.orderstatus==6">
              <el-tag
              round
              type="danger"
              disable-transitions
              ><span
                v-text="util.showOrderStatus(scope.row.orderstatus)"
              ></span>
              </el-tag>
            </template>
          </template>
        </el-table-column>
        
        <el-table-column
          label="收货人姓名"
          align="center"
          prop="orderAddress.receiver"
          width="100"
        />
        <el-table-column
          label="收货人电话"
          prop="orderAddress.receiverphone"
          width="120"
        />
        <el-table-column
          label="快递单号"
          prop="orderAddress.expressnum"
          width="100"
        />
        <!-- <el-table-column
          label="发货时间"
          prop="orderAddress.deliveryed"
          width="150"
        >
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(
                  scope.row.orderAddress.deliveryed,
                  'yyyy-MM-dd hh:mm'
                )
              "
            ></span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="客户下单备注" prop="ordernote" width="150" /> -->
        <el-table-column label="异常订单状态" prop="abnormalstatus" width="150">
          <template #default="scope">
            {{util.showOrderAbnormalStatus(scope.row.abnormalstatus)}}
          </template>
        </el-table-column>
        <el-table-column label="异常订单备注" prop="abnormalnote" width="150" />
        <el-table-column label="异常订单备注时间" prop="abnormaled" width="200" />
        <el-table-column label="订单标识" prop="orderidentifier" width="150" />
        <el-table-column label="后端处理备注" prop="orderAddress.deliverynote" width="200" />
        
        <el-table-column label="操作" fixed="right" width="110">
          <template #default="scope" style="padding:0">
            <el-link
              type="primary"
              size="small"
              @click="showSaleNewDialog(scope.row)"
              v-hasPermission="['order:sale']"
              >售后</el-link>
            <el-link
              type="primary"
              size="small"
              @click="showDeliverGoodsDialog(scope.row)"
              v-hasPermission="['order:sendodd']"
              v-text="scope.row.orderstatus==4||scope.row.orderstatus==5?'单号':'发货'"
              ></el-link>
            <el-link
              type="primary"
              size="small"
              @click="open('order:view', scope.row)"
              v-hasPermission="['order:view']"
              >详情</el-link>
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doOrderEdit(scope.$index, scope.row)"
              v-hasPermission="['order:edit']"
              >编辑</el-link>

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此订单吗？"
              width="200px"
              @confirm="doOrderDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link>
              </template>
            </el-popconfirm>
            
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-row class="row-bg">
    <el-col :span="24">
      <div>
        <el-button type="danger" @click="showBatchOrderAccountDialog" v-hasPermission="['order:batch']">批量修改订单金额</el-button>
        <el-button type="danger" @click="showBatchOrderStatusDialog" v-hasPermission="['order:batch']">批量修改订单状态</el-button>
        <el-button type="danger" @click="showBatchOrderSupplierDialog" v-hasPermission="['order:batch']">批量修改供应商</el-button>
        <el-button type="danger" @click="showBatchOrderPlatformnumDialog" v-hasPermission="['order:batch']">批量修改平台订单号</el-button>
        <el-button type="danger" @click="showBatchOrderSaleDialog" v-hasPermission="['order:batch']">批量新建售后</el-button>
      </div>
    </el-col>
  </el-row>
    <el-row style="display: contents;">
      <el-col :span="24">
        <div style="float: right">
          <el-pagination
            v-model:page-size="queryParam.pageSize"
            :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changeChangeSize"
            @current-change="changePage"
            :current-page="queryParam.pageNo"
          />
        </div>
      </el-col>
    </el-row>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="45%"
    @close="doOrderClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="orderFormRef"
        :model="orderForm"
        :rules="rules"
        label-width="150px"
        autocomplete="off"
      >
        <h1 style="margin-top: 0">订单基本信息</h1>
        <el-form-item label="平台交易时间" prop="platformed">{{
          util.formatDateUnix(orderForm.platformed, "yyyy-MM-dd hh:mm")
        }}</el-form-item>
        <el-form-item label="垚旌订单时间" prop="created">{{
          util.formatDateUnix(orderForm.created, "yyyy-MM-dd hh:mm")
        }}</el-form-item>
        <!-- <el-form-item label="平台订单号" prop="platformnum">{{
          orderForm.platformnum
        }}</el-form-item> -->

        <el-form-item label="平台订单号" prop="platformnum">
            <el-input
              v-model="orderForm.platformnum"
              placeholder="请输入平台订单号"
            />
          </el-form-item>

        <el-form-item label="垚旌订单号" prop="ordernum">{{
          orderForm.ordernum
        }}</el-form-item>

        <el-form-item label="订单类型">常规订单</el-form-item>

        <el-form-item label="订单状态">
          <el-select
            v-model="orderForm.orderstatus"
            placeholder="订单状态"
            style="width: 100%"
          >
            <el-option label="待发货" :value="1" />
            <el-option label="备货中" :value="2" />
            <el-option label="发货失败" :value="3" />
            <el-option label="已发货" :value="4" />
            <el-option label="发货完结" :value="5" />
            <el-option label="已取消" :value="6" />
          </el-select>
        </el-form-item>

        <el-form-item label="收货人姓名" prop="receiver">
          <el-input
            v-model.trim="orderForm.orderAddress.receiver"
            placeholder="请输入收货人姓名"
          />
        </el-form-item>

        <el-form-item label="收货人电话" prop="receiverphone">
          <el-input
            v-model.trim="orderForm.orderAddress.receiverphone"
            placeholder="请输入收货人电话"
          />
        </el-form-item>

        <el-form-item label="收货地址" prop="receiveraddress">
          <el-input
            v-model.trim="orderForm.orderAddress.receiveraddress"
            placeholder="请输入收货地址"
          />
        </el-form-item>
        <el-form-item label="客户下单备注" prop="ordernote">
          <el-input
            v-model.trim="orderForm.ordernote"
            placeholder="请输入客户下单备注"
          />
        </el-form-item>
        <el-form-item label="异常订单状态" prop="abnormalstatus">
          <el-select v-model="orderForm.abnormalstatus" placeholder="请选择异常订单状态">
            <el-option label="未处理" :value="1" />
            <el-option label="跟进中" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="异常订单备注" prop="abnormalnote">
          <el-input
            v-model.trim="orderForm.abnormalnote"
            placeholder="请输入异常订单备注"
          />
        </el-form-item>
        <el-form-item label="异常订单备注时间" prop="abnormaled">
          <el-date-picker
            v-model="orderForm.abnormaled"
            type="datetime"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="请输入异常订单备注时间"
          />
        </el-form-item>
        <el-form-item label="订单备注1" prop="ordernote1">
          <el-input
            v-model.trim="orderForm.ordernote1"
            placeholder="请输入订单备注1"
          />
        </el-form-item>
        <el-form-item label="订单备注2" prop="ordernote2">
          <el-input
            v-model.trim="orderForm.ordernote2"
            placeholder="请输入订单备注2"
          />
        </el-form-item>
        <el-form-item label="订单备注3" prop="ordernote3">
          <el-input
            v-model.trim="orderForm.ordernote3"
            placeholder="请输入订单备注3"
          />
        </el-form-item>
        <el-form-item label="订单标识" prop="orderidentifier">
          <el-select
              style="width: 100%"
              v-model="orderForm.orderidentifier"
              filterable
              placeholder="选择订单标识"
              @change="getOrderIdentifier"
              ref="orderIdentifierRef"
            >
              <template v-for="item in orderIdentifierData" :key="item.identifierid">
                <el-option :label="item.identifiername" :value="item.identifiername" />
              </template>
            </el-select>
        </el-form-item>

        <el-divider />
        <el-card class="box-card" shadow="never" style="margin-bottom: 10px">
          <template #header>
            <div class="card-header">
              <span>订单金额信息</span>
            </div>
          </template>
          <el-form-item label="销售金额" prop="saleamount">
            <el-input
              v-model="orderForm.saleamount"
              placeholder="请输入销售金额"
            />
          </el-form-item>
          <el-form-item label="成本金额" prop="costamount">
            <el-input
              v-model="orderForm.costamount"
              placeholder="请输入成本金额"
            />
          </el-form-item>
          <el-form-item label="实发数量" prop="realqty">
            <el-input-number
              v-model="orderForm.realqty"
              :min="0"
              :max="1"
              controls-position="right"
            />
            <!-- <el-input
            v-model.number="orderForm.realqty"
              placeholder="请输入实发数量"
            /> -->
          </el-form-item>
          <el-form-item label="毛利额" prop="maolieamount">¥ 
            <span v-if="orderForm.maolieamount" v-text="(orderForm.maolieamount).toFixed(2)" />
          </el-form-item>
          <el-form-item label="毛利率" prop="maoliv">
            <span v-if="orderForm.maoliv" v-text="(orderForm.maoliv*100).toFixed(2) + '%'" />
          </el-form-item>
        </el-card>

        <el-card class="box-card" shadow="never" style="margin-bottom: 10px">
          <template #header>
            <div class="card-header">
              <span>订单商品信息</span>
            </div>
          </template>
          <el-form-item label="商品ID">{{
            orderForm.orderGoods.goodsnum
          }}</el-form-item>
          <el-form-item label="商品名称">{{
            orderForm.orderGoods.goodsname
          }}</el-form-item>
          <el-form-item label="商品类目">{{
            orderForm.orderGoods.catalogname
          }}</el-form-item>
          <el-form-item label="商品品牌">{{
            orderForm.orderGoods.brandname
          }}</el-form-item>
          <el-form-item label="商品类型">{{
            orderForm.orderGoods.typename
          }}</el-form-item>
          <el-form-item label="商品规格">{{
            orderForm.orderGoods.specification
          }}</el-form-item>
          <el-form-item label="商品描述"
            >{{ orderForm.orderGoods.desc }}</el-form-item
          >
          <el-form-item label="税收编码">{{
            orderForm.orderGoods.taxcode
          }}</el-form-item>
          <el-form-item label="税收分类名称">{{
            orderForm.orderGoods.taxsort
          }}</el-form-item>
          <el-form-item label="国际条形码">{{
            orderForm.orderGoods.barcode
          }}</el-form-item>
          <el-form-item label="礼包单品SKU编码">{{
            orderForm.orderGoods.giftsku
          }}</el-form-item>
          <el-form-item label="电商评价数">{{
            orderForm.orderGoods.erate
          }}</el-form-item>
          <el-form-item label="电商链接">{{
            orderForm.orderGoods.elink
          }}</el-form-item>
          <el-form-item label="产地">{{
            orderForm.orderGoods.producer
          }}</el-form-item>
          <el-form-item label="发货快递要求">{{
            orderForm.orderGoods.expressdemand
          }}</el-form-item>
          <el-form-item label="商品备注1">{{
            orderForm.orderGoods.note1
          }}</el-form-item>
          <el-form-item label="商品备注2">{{
            orderForm.orderGoods.note2
          }}</el-form-item>
          <el-form-item label="发货地">{{
            orderForm.orderGoods.delivery
          }}</el-form-item>
          <el-form-item label="发货快递">{{
            orderForm.orderGoods.express
          }}</el-form-item>
          <el-form-item label="成本价">¥ 
            <span v-if="orderForm.orderGoods.costprice" v-text="(orderForm.orderGoods.costprice).toFixed(2)" />
          </el-form-item>
          <el-form-item label="市场价">¥ 
            <span v-if="orderForm.orderGoods.marketprice" v-text="(orderForm.orderGoods.marketprice).toFixed(2)" />
          </el-form-item>
        </el-card>

        <el-divider />
        <el-card class="box-card" shadow="never" style="margin-bottom: 10px">
          <template #header>
            <div class="card-header">
              <span>订单发货信息</span>
            </div>
          </template>
          <el-form-item label="发货时间">{{
            util.formatDateUnix(
              orderForm.orderAddress.deliveryed,
              "yyyy-MM-dd hh:mm"
            )
          }}</el-form-item>
          <el-form-item label="快递单号" prop="expressnum">
            <el-input
              v-model="orderForm.orderAddress.expressnum"
              placeholder="输入快递单号"
            />
          </el-form-item>
          <el-form-item label="快递公司" prop="expresscompany">
            <el-input
              v-model="orderForm.orderAddress.expresscompany"
              placeholder="输入快递公司"
            />
          </el-form-item>
          <el-form-item label="运费金额" prop="orderAddress.freightamount">
            <el-input
              v-model="orderForm.orderAddress.freightamount"
              placeholder="输入运费金额"
            />
          </el-form-item>
          <el-form-item label="后端处理备注" prop="deliverynote">
            <el-input
              v-model="orderForm.orderAddress.deliverynote"
              placeholder="输入后端处理备注"
            />
          </el-form-item>
        </el-card>

        <el-divider />
        <el-card class="box-card" shadow="never" style="margin-bottom: 10px">
          <template #header>
            <div class="card-header">
              <span>客户信息</span>
            </div>
          </template>
          <el-form-item label="客户" prop="customerid" v-if="customerSelect">
            <el-select
              style="width: 100%"
              v-model="orderForm.customerid"
              filterable
              placeholder="选择客户"
              @change="getCustomer"
              ref="customerRef"
            >
              <template v-for="item in customerData" :key="item.customerid">
                <el-option :label="item.name" :value="item.customerid" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="客户">
            {{ orderForm.customer.name }}
            <el-link
              style="margin-left: 10px"
              type="primary"
              size="small"
              :underline="false"
              @click="(customerSelect = true)"
              >编辑</el-link
            >
          </el-form-item>
          <el-form-item label="收款方式">{{
            util.showPaidWay(orderForm.customer.paidway)
          }}</el-form-item>
          <el-form-item label="应收金额">¥ 
            <span v-if="orderForm.orderVerify.cuspaidamount" v-text="(orderForm.orderVerify.cuspaidamount).toFixed(2)" />
          </el-form-item>
          <el-form-item label="收款账户">{{
            orderForm.customer.paidaccount
          }}</el-form-item>
          <el-form-item label="客户对账时间">{{
            util.formatDateUnix(
              orderForm.orderVerify.cuspaided,
              "yyyy-MM-dd hh:mm"
            )
          }}</el-form-item>
          <el-form-item label="有无合同">{{
            util.showYesNo(orderForm.customer.iscontract)
          }}</el-form-item>
          <el-form-item label="有无账期">{{
            util.supplierAccount(orderForm.customer.isaccount)
          }}</el-form-item>
          <el-form-item label="有无开票">{{
            util.showYesNo(orderForm.orderVerify.cusistax)
          }}</el-form-item>
          <el-form-item label="发票类型">{{
            util.showInvoiceType(orderForm.orderVerify.custaxtype)
          }}</el-form-item>
          <el-form-item label="开票税点">{{
            orderForm.customer.taxpoint
          }}</el-form-item>
        </el-card>

        <el-divider />
        <el-card class="box-card" shadow="never" style="margin-bottom: 10px">
          <template #header>
            <div class="card-header">
              <span>供应商信息</span>
            </div>
          </template>
          <el-form-item label="供应商" prop="supplierid" v-if="supplierSelect">
            <el-select
              style="width: 100%"
              v-model="orderForm.supplierid"
              filterable
              placeholder="选择供应商"
              ref="supplierRef"
            >
              <template v-for="item in supplierData" :key="item.supplierid">
                <el-option :label="item.name" :value="item.supplierid" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商">
            {{ orderForm.supplier.name }}
            <el-link
              style="margin-left: 10px"
              type="primary"
              size="small"
              :underline="false"
              @click="(supplierSelect = true)"
              >编辑</el-link
            >
          </el-form-item>
          <el-form-item label="付款方式">{{
            util.showPayWay(orderForm.supplier.payway)
          }}</el-form-item>
          <el-form-item label="付款金额">¥
            <span v-if="orderForm.orderVerify.suppayamount" v-text="(orderForm.orderVerify.suppayamount).toFixed(2)" />
          </el-form-item>
          <el-form-item label="付款账户">{{
            orderForm.supplier.payaccount
          }}</el-form-item>
          <el-form-item label="有无合同">{{
            util.showYesNo(orderForm.supplier.iscontract)
          }}</el-form-item>
          <el-form-item label="有无账期">{{
            util.supplierAccount(orderForm.supplier.isaccount)
          }}</el-form-item>
          <el-form-item label="供应商对账时间">{{
            util.formatDateUnix(
              orderForm.orderVerify.suppayed,
              "yyyy-MM-dd hh:mm"
            )
          }}</el-form-item>
          <el-form-item label="有无开票">{{
            util.showYesNo(orderForm.orderVerify.supistax)
          }}</el-form-item>
          <el-form-item label="发票类型">{{
            util.showInvoiceType(orderForm.orderVerify.suptaxtype)
          }}</el-form-item>
          <el-form-item label="开票税点">{{
            orderForm.supplier.taxpoint
          }}</el-form-item>
        </el-card>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doOrderClose()">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doOrderSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>

  <SaleNew ref="RefSaleNew"  @click="getListOrder" />
  <DeliverGoods ref="RefDeliverGoods" @click="getListOrder" />
  <BatchOrderAccount ref="RefBatchOrderAccount" @click="getListOrder"/>
  <BatchOrderStatus ref="RefBatchOrderStatus" @click="getListOrder"/>
  <BatchOrderPlatformnum ref="RefBatchOrderPlatformnum" @click="getListOrder"/>
  <BatchOrderSupplier ref="RefBatchOrderSupplier" @click="getListOrder"/>
  <BatchOrderSaleNew ref="RefBatchOrderSale" @click="getListOrder"/>
  <ExportOrder ref="RefExportOrder" />
</template>
        
<script setup>
import { ref, onMounted, getCurrentInstance, nextTick } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listOrder, saveOrder, getOrderInfo, getOrderCount, deleteOrder,exportOrder, exportOrderSupplier } from "@/api/order";
import { listOrderIdentifierCache } from "@/api/order/identifier";

import { listSupplierCache } from "@/api/supplier";
import { listCustomerCache } from "@/api/customer";
import util from "@/util/tool.js";
import storage from  "@/util/storage";


// import store from "@/store";

import SaleNew from "@/components/common/saleNew";
import DeliverGoods from "@/components/common/deliverGoods";
import BatchOrderAccount from "@/components/common/batchOrderAccount";
import BatchOrderStatus from "@/components/common/batchOrderStatus";
import BatchOrderPlatformnum from "@/components/common/batchOrderPlatformnum";
import BatchOrderSupplier from "@/components/common/batchOrderSupplier";
import BatchOrderSaleNew from "@/components/common/batchOrderSaleNew";
import ExportOrder from "@/components/common/exportOrder";

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("orderPath",queryParam.value)

  router.push({
    name: routeName,
    params: { id: row.orderid },
    //query: { name: row.name },
  });
};
let openImport = (routeName) => {
  router.push({
    name: routeName,
  });
};

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const orderFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

// let dateRange = ref([]);

let dateStartRange = ref();
let dateEndRange = ref();

let title = ref("新增订单");

const activeTabName = ref("all");
const doTabClick = (tab) => {
  let status = '';
  if (tab.props.name === 'all') {
    status = '';
  } else if (tab.props.name == 'wait') {
    status = 1;
  } else if (tab.props.name == 'pending') {
    status = 2;
  } else if (tab.props.name == 'fail') {
    status = 3;
  } else if (tab.props.name == 'success') {
    status = 4;
  } else if (tab.props.name == 'completed') {
    status = 5;
  } else if (tab.props.name == 'cancel') {
    status = 6;
  }
  queryParam.value.orderstatus = status;
  queryParam.value.platformed = null;
  getListOrder();
};

const getPendingOrder = (platformed) => {
  queryParam.value.orderstatus = 2;
  queryParam.value.platformed = platformed;
  getListOrder();
}

const multipleSelection = ref([]);
const doSelectionOrder = (val) => {
  multipleSelection.value = val;
};

const supplierSelect = ref(false);
const customerSelect = ref(false);

//订单导出
let dialogExportOrderVisible = ref(false);
const RefExportOrder = ref();
const showExportOrderDialog = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  RefExportOrder.value.changeVisible(!dialogExportOrderVisible.value);
  RefExportOrder.value.exportOrderMethod(queryParam.value);
  RefExportOrder.value.exportAction('order');
};

//新建售后
let dialogSaleNewVisible = ref(false);
const RefSaleNew = ref();
const showSaleNewDialog = (obj) => {
  RefSaleNew.value.changeVisible(!dialogSaleNewVisible.value);
  // console.log((typeof obj.orderSales.oldsaleamount === 'undefined'))
  RefSaleNew.value.saleMethod({
    saleid: obj.orderSales ? obj.orderSales.saleid : '',
    saletype: obj.orderSales ? obj.orderSales.saletype : '',
    salenote: obj.orderSales ? obj.orderSales.salenote : '',
    salestatus: obj.orderSales ? obj.orderSales.salestatus : '',
    orderid: obj.orderid,
    goodsid: obj.orderGoods.goodsid,
    oldsaleamount: obj.orderSales ? (obj.orderSales.oldsaleamount?obj.orderSales.oldsaleamount:obj.saleamount) : obj.saleamount,
    oldcostamount: obj.orderSales ? (obj.orderSales.oldcostamount?obj.orderSales.oldcostamount:obj.costamount) : obj.costamount,
  });
};

//订单发货
let dialogDeliverGoodsVisible = ref(false);
const RefDeliverGoods = ref();
const showDeliverGoodsDialog = (obj) => {
  RefDeliverGoods.value.changeVisible(!dialogDeliverGoodsVisible.value);
  RefDeliverGoods.value.receiverMethod({
    expressnum: obj.orderAddress.expressnum,
    expresscompany: obj.orderAddress.expresscompany,
    freightamount: obj.orderAddress.freightamount,
    deliverynote: obj.orderAddress.deliverynote,
    receiver: obj.orderAddress.receiver,
    receiverphone: obj.orderAddress.receiverphone,
    receiveraddress: obj.orderAddress.receiveraddress,
    orderid: obj.orderid,
    goodsid: obj.orderGoods.goodsid,
  });
};

let dialogBatchOrderAccountVisible = ref(false);
const RefBatchOrderAccount = ref();
const showBatchOrderAccountDialog = () => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的订单项');
    return false
  }
  RefBatchOrderAccount.value.changeVisible(!dialogBatchOrderAccountVisible.value);

  let orderids = []
  let maolivs = []
  let maolivges = []
  let freightamounts = []
  let saleamounts = []
  let costamounts = []

  multipleSelection.value.forEach((order) => {
      orderids.push(order.orderid.toString())
      maolivs.push(order.customer.maoliv)
      maolivges.push(order.customer.maolivge)
      freightamounts.push(order.orderAddress.freightamount)
      saleamounts.push(order.saleamount)
      costamounts.push(order.costamount)
  });

  // console.log(orderids.join(','))
  // console.log(maolivs.join(','))
  // console.log(maolivges.join(','))

  RefBatchOrderAccount.value.orderAccountMethod({
    orderid: orderids,
    maoliv: maolivs,
    maolivge: maolivges,
    freightamount: freightamounts,
    saleamount: saleamounts,
    costamount: costamounts
  });
};

let dialogBatchOrderStatusVisible = ref(false);
const RefBatchOrderStatus = ref();
const showBatchOrderStatusDialog = () => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的订单项');
    return false
  }
  RefBatchOrderStatus.value.changeVisible(!dialogBatchOrderStatusVisible.value);

  let orderids = []

  multipleSelection.value.forEach((order) => {
      orderids.push(order.orderid.toString())
  });

  RefBatchOrderStatus.value.orderStatusMethod({
    orderid: orderids,
  });
};

let dialogBatchOrderPlatformnumVisible = ref(false);
const RefBatchOrderPlatformnum = ref();
const showBatchOrderPlatformnumDialog = () => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的订单项');
    return false
  }
  RefBatchOrderPlatformnum.value.changeVisible(!dialogBatchOrderPlatformnumVisible.value);

  let orderids = []

  multipleSelection.value.forEach((order) => {
      orderids.push(order.orderid.toString())
  });

  RefBatchOrderPlatformnum.value.orderPlatformnumMethod({
    orderid: orderids,
  });
};

let dialogBatchOrderSupplierVisible = ref(false);
const RefBatchOrderSupplier = ref();
const showBatchOrderSupplierDialog = () => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的订单项');
    return false
  }
  RefBatchOrderSupplier.value.changeVisible(!dialogBatchOrderSupplierVisible.value);

  let orderids = []

  multipleSelection.value.forEach((order) => {
      orderids.push(order.orderid.toString())
  });

  RefBatchOrderSupplier.value.orderSupplierMethod({
    orderid: orderids,
    suppliers: supplierData.value
  });
};

let dialogBatchOrderSaleVisible = ref(false);
const RefBatchOrderSale = ref();
const showBatchOrderSaleDialog = () => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的订单项');
    return false
  }

  let orderids = []
  let goodsid = []
  let oldsaleamounts = []
  let oldcostamounts = []

  multipleSelection.value.forEach((order) => {
    if (typeof order.orderSales === 'undefined') {
      let oldsaleamount = order.orderSales ? (order.orderSales.oldsaleamount?order.orderSales.oldsaleamount:order.saleamount) : order.saleamount
      let oldcostamount = order.orderSales ? (order.orderSales.oldcostamount?order.orderSales.oldcostamount:order.costamount) : order.costamount
      orderids.push(order.orderid.toString())
      goodsid.push(order.orderGoods.goodsid)
      oldsaleamounts.push(oldsaleamount)
      oldcostamounts.push(oldcostamount)

    }
  });

  if (orderids.length<=0) {
    ElMessage.error('此订单已有售后');
    return false
  }

  RefBatchOrderSale.value.changeVisible(!dialogBatchOrderSaleVisible.value);

  RefBatchOrderSale.value.orderSaleMethod({
    orderid: orderids,
    goodsid: goodsid,
    oldsaleamount: oldsaleamounts,
    oldcostamount: oldcostamounts
  });
};


//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  platformed: "",
  platformnum: "",
  ordernum: "",
  pordernum: "",
  pname: "",
  name: "",
  goodsnum: "",
  orderidentifier: "",
  abnormalstatus: "",
  customerid: "",
  supplierid: "",
  expressnum: "",
  receiver: "",
  receiverphone: "",
  maolivstatus: "",
  orderstatus: "",
  created: "",
  changed: "",
});

const autoFormat = (key, opt = {}) => {
  queryParam.value[key] = util.formatLineText(queryParam.value[key], opt);
};

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    platformed: "",
    platformnum: "",
    ordernum: "",
    pordernum: "",
    pname: "",
    name: "",
    goodsnum: "",
    orderidentifier: "",
    abnormalstatus: "",
    customerid: "",
    supplierid: "",
    expressnum: "",
    receiver: "",
    receiverphone: "",
    maolivstatus: "",
    orderstatus: "",
    created: "",
    changed: "",
  };
  defaultDate()
  getListOrder();
};

const orderForm = ref({
  orderid: null,
  supplierid: null,
  customerid: null,
  name: "",
  platformnum: "",
  ordernum: "",
  ordertype: "",
  saleamount: "",
  costamount: "",
  realqty: 0,
  maolieamount: "",
  maoliv: "",
  maolivstatus: "",
  orderstatus: "",
  ordernote: "",
  abnormalstatus: "",
  abnormalnote: "",
  abnormaled: "",
  ordernote1: "",
  ordernote2: "",
  ordernote3: "",
  orderidentifier: "",
  platformed: "",
  completed: "",
  created: "",
  changed: "",
  orderAddress: {
    receiver: "",
    receiverphone: "",
    receiveraddress: "",
    expressnum: "",
    expresscompany: "",
    deliveryed: "",
    freightamount: "",
    deliverynote: "",
  },
  orderGoods: {
    goodsid: "",
    goodsnum: "",
    goodsname: "",
    catalogname: "",
    brandname: "",
    specification: "",
    costprice: "",
    marketprice: "",
    // discount: "",
    desc: "",
    taxcode: "",
    taxsort: "",
    barcode: "",
    erate: "",
    elink: "",
    producer: "",
    note1: "",
    note2: "",
    delivery: "",
    express: "",
  },
  orderVerify: {
    cuscompensation: "",
    cusistax: "",
    cuspaidamount: "",
    cussetstatus: "",
    cusstatus: "",
    cuspaided: "",
    custaxtype: "",
    supcompensation: "",
    supistax: "",
    suppayamount: "",
    supsetstatus: "",
    supstatus: "",
    suppayed: "",
    suptaxtype: "",
  },
  customer: {
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    paidway: "",
    paidaccount: "",
    maoliv: "",
    maolivge: "",
  },
  supplier: {
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    payway: "",
    payaccount: "",
    taxpoint: "",
  },
});

// const resetForm = () => {
//   orderForm.value = {
//     orderid: null,
//     supplierid: null,
//     customerid: null,
//     name: "",
//     platformnum: "",
//     ordernum: "",
//     ordertype: "",
//     saleamount: "",
//     costamount: "",
//     maolieamount: "",
//     maoliv: "",
//     maolivstatus: "",
//     orderstatus: "",
//     ordernote: "",
//     platformed: "",
//     completed: "",
//     created: "",
//     changed: "",
//     orderAddress: {
//       receiver: "",
//       receiverphone: "",
//       receiveraddress: "",
//       expressnum: "",
//       expresscompany: "",
//       deliveryed: "",
//       freightamount: "",
//       deliverynote: "",
//     },
//     orderGoods: {
//       goodsid: "",
//       goodsnum: "",
//       goodsname: "",
//       catalogname: "",
//       brandname: "",
//       specification: "",
//       costprice: "",
//       marketprice: "",
//     },
//     orderVerify: {
//       cuscompensation: "",
//       cusistax: "",
//       cuspaidamount: "",
//       cussetstatus: "",
//       cusstatus: "",
//       cuspaided: "",
//       custaxtype: "",
//       supcompensation: "",
//       supistax: "",
//       suppayamount: "",
//       supsetstatus: "",
//       supstatus: "",
//       suppayed: "",
//       suptaxtype: "",
//     },
//     customer: {
//       name: "",
//       balanceway: "",
//       iscontract: "",
//       isaccount: "",
//       paidway: "",
//       paidaccount: "",
//       maoliv: "",
//       maolivge: "",
//     },
//     supplier: {
//       name: "",
//       balanceway: "",
//       iscontract: "",
//       isaccount: "",
//       payway: "",
//       payaccount: "",
//       taxpoint: "",
//     },
//   };
// };

// const defaultDate = () => {
//     const today = new Date()
    
//     // 一年前的日期
//     const startDate = new Date(today)
//     startDate.setFullYear(startDate.getFullYear() - 1)
  
//     // 格式化 YYYY-MM-DD
//     const formatDate = (date) => date.toISOString().slice(0, 10)
  
//     // 默认赋值
//     dateRange.value = [
//       formatDate(startDate),
//       formatDate(today)
//     ]
//     queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
//     queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
//   }
//   // 2. 禁用逻辑：不能选未来，范围最大一年
//   const disabledDate = (time) => {
//     const now = Date.now()
//     const oneYearMs = 365 * 24 * 60 * 60 * 1000
  
//     // 禁用未来日期
//     if (time.getTime() > now) return true
  
//     // 已选开始日期 → 结束日期只能选 开始 ~ 开始+1年
//     if (dateRange.value?.[0]) {
//       const start = new Date(dateRange.value[0]).getTime()
//       return time.getTime() < start || time.getTime() > start + oneYearMs
//     }
  
//     return false
//   }
  
//   // 3. 防止手动输入超过一年范围
//   const handleDateChange = () => {
//     if (!dateRange.value) return
  
//     const start = new Date(dateRange.value[0]).getTime()
//     const end = new Date(dateRange.value[1]).getTime()
//     const oneYearMs = 365 * 24 * 60 * 60 * 1000
  
//     if (end - start > oneYearMs) {
//       const maxEnd = new Date(start + oneYearMs)
//       dateRange.value[1] = maxEnd.toISOString().slice(0, 10)
//     }
//     queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
//     queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
//   }

const defaultDate = () => {
    const today = new Date()
    const halfYearAgo = new Date(today)
    // 往前推6个月
    halfYearAgo.setMonth(halfYearAgo.getMonth() - 6)

    // 格式化日期 YYYY-MM-DD
    const formatDate = (date) => date.toISOString().slice(0, 10)

    // 赋值默认范围
    // dateRange.value = [
    //   formatDate(halfYearAgo),
    //   formatDate(today)
    // ]
    // queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
    // queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");

     dateStartRange.value =  formatDate(halfYearAgo)
     dateEndRange.value = formatDate(today)
     queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
     queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
  }
// 2. 禁用逻辑：不能选未来，范围最6个月
const disabledDate = (time) => {
  console.log(time)
  // const now = Date.now()

  // 1. 禁用未来日期
  // if (time.getTime() > now) return true

  // 2. 已选开始日期 → 结束日期只能选 开始 ~ 开始+6个月
  // if (dateRange.value?.[0]) {
  //   const start = new Date(dateRange.value[0])
  //   const maxEnd = new Date(start)
  //   maxEnd.setMonth(maxEnd.getMonth() + 6) // 加6个月

  //   return time.getTime() < start || time.getTime() > maxEnd
  // }
  // if (dateStartRange.value) {
  //   const start = new Date(dateStartRange.value)
  //   const maxEnd = new Date(start)
  //   maxEnd.setMonth(maxEnd.getMonth() + 6) // 加6个月

  //   return time.getTime() < start || time.getTime() > maxEnd
  // }

  // return false
}
// 三、防止手动输入超过6个月
// const handleDateChange = () => {
//   if (!dateRange.value[0] || !dateRange.value[1]) return

//   const start = new Date(dateRange.value[0])
//   const end = new Date(dateRange.value[1])
//   const maxEnd = new Date(start)
//   maxEnd.setMonth(maxEnd.getMonth() + 6)

//   // 如果超出6个月，自动修正结束时间
//   if (end > maxEnd) {
//     dateRange.value[1] = maxEnd.toISOString().slice(0, 10)
//   }
//   queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
//   queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
// }

const handleDateStartChange = () => {
  if (!dateStartRange.value) return
  if (dateEndRange.value) {
    if (dateStartRange.value > dateEndRange.value) {
      dateStartRange.value = ""
      queryParam.value.created = ""
      ElMessage.error('开始时间须小于结束时间');
      return false
    }
  }
  queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
}

const handleDateEndChange = () => {
  if (!dateEndRange.value) return

  if (dateStartRange.value > dateEndRange.value) {
    dateStartRange.value = ""
    queryParam.value.created = ""
    ElMessage.error('开始时间须小于结束时间');
    return false
  }
  queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
}

let currentInstance = null;
const customerRef = ref();
const getCustomer = (selectedValue) => {
  console.log(selectedValue)
  nextTick(() => {
    // 这里不加nextTick会获取不到准确的值
    const { selectedLabel } = currentInstance.refs.customerRef;
    orderForm.value.customername = selectedLabel;
  });
};

const orderIdentifierRef = ref();
const getOrderIdentifier = (selectedValue) => {
  console.log(selectedValue)
  nextTick(() => {
    // 这里不加nextTick会获取不到准确的值
    const { selectedLabel } = currentInstance.refs.orderIdentifierRef;
    orderForm.value.orderidentifier = selectedLabel;
  });
};

const tableData = ref([]);

const countOrderPending = ref([])
const countOrderTitle = ref([])
const getOrderCounts = () => {
  getOrderCount({orderstatus:2}).then((res)=>{
    countOrderPending.value = res.data.extend.countsPending
    countOrderTitle.value = res.data.extend.countsTitle
  })
}

//订单标识列表API
const orderIdentifierData = ref([]);
const orderIdentifierReset = (identifiers) => {
  let dataTmp = [];
  identifiers.forEach((identifier) => {
    identifier.identifierid = identifier.identifierid.toString();
    dataTmp.push(identifier);
  });
  return dataTmp;
};
const getListOrderIdentifier = () => {
  listOrderIdentifierCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    orderIdentifierData.value = orderIdentifierReset(res.data.extend.pages.list);
  });
};

//客户列表API
const customerData = ref([]);
const customerReset = (customers) => {
  let dataTmp = [];
  customers.forEach((customer) => {
    customer.customerid = customer.customerid.toString();
    dataTmp.push(customer);
  });
  return dataTmp;
};
const getListCustomer = () => {
  listCustomerCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    customerData.value = customerReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplierCache({ pageNo: 1, pageSize: 5000}).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

// const doOrderAdd = () => {
//   title.value = "新增订单";
//   resetForm();
// };

const doOrderEdit = (index, obj) => {
  title.value = "编辑订单";
  let orderid = obj.orderid.toString();
  getOrderInfo({ orderid }).then((res) => {
    orderForm.value = res.data.extend.order;
    orderForm.value.orderid = res.data.extend.order.orderid.toString();
    orderForm.value.supplierid = res.data.extend.order.supplierid.toString();
    orderForm.value.customerid = res.data.extend.order.customerid.toString();
  });
};

const doOrderClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  orderFormRef.value.resetFields();
};

const doOrderSave = () => {
  orderFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    let maolivstatus = 2;
    let maoliv = orderForm.value.saleamount / orderForm.value.costamount;
    if (
      maoliv >= orderForm.value.customer.maoliv &&
      maoliv <= orderForm.value.customer.maolivge
    ) {
      maolivstatus = 1;
    }

    let data = {
      order: {
        orderid: orderForm.value.orderid,
        name: orderForm.value.name,
        orderstatus: orderForm.value.orderstatus,
        platformnum: orderForm.value.platformnum,

        ordernote: orderForm.value.ordernote,

        abnormalstatus: orderForm.value.abnormalstatus,
        abnormalnote: orderForm.value.abnormalnote,
        abnormaled: orderForm.value.abnormaled,
        ordernote1: orderForm.value.ordernote1,
        ordernote2: orderForm.value.ordernote2,
        ordernote3: orderForm.value.ordernote3,
        orderidentifier: orderForm.value.orderidentifier,


        saleamount: orderForm.value.saleamount,
        costamount: orderForm.value.costamount,
        realqty: orderForm.value.realqty,
        maolieamount: orderForm.value.saleamount - orderForm.value.costamount,
        maoliv: orderForm.value.saleamount / orderForm.value.costamount,
        supplierid: orderForm.value.supplierid,
        customerid: orderForm.value.customerid,
        maolivstatus: maolivstatus,
      },

      orderAddress: {
        receiver: orderForm.value.orderAddress.receiver,
        receiverphone: orderForm.value.orderAddress.receiverphone,
        receiveraddress: orderForm.value.orderAddress.receiveraddress,
        expressnum: orderForm.value.orderAddress.expressnum,
        expresscompany: orderForm.value.orderAddress.expresscompany,
        freightamount: orderForm.value.orderAddress.freightamount,
        deliverynote: orderForm.value.orderAddress.deliverynote,
      },
    };

    saveOrder(data).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListOrder();
          doOrderClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListOrder();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListOrder();
};

const doOrderDelete = (index, obj) => {
  deleteOrder(obj).then((res) => {
    if (res.data.code === 1) {
      getListOrder();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//订单表API
const getListOrder = () => {
  storage.remove('orderPath')


  if (!dateStartRange.value || !dateEndRange.value) {
    defaultDate()
  }

  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.supplierids = query.supplierid?query.supplierid.join(','):''
  query.customerids = query.customerid?query.customerid.join(','):''
  delete query.customerid
  delete query.supplierid
  console.log(query)

  listOrder(query).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false;
    // getOrderCounts();
  });
};

const validateDecimal = (rule, value, callback) => {
  if (typeof value === 'undefined') { callback();}
  //   const reg = /^d*(?:.d{0,2})?$/;
  console.log('value----',value)
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};

//表单验证规则
const rules = ref({
  saleamount: [
    {
      required: true,
      message: "请输入销售金额",
      trigger: "blur",
    },
    {
      required: true,
      validator: validateDecimal,
      trigger: "blur",
    }
  ],
  costamount: [
  {
      required: true,
      message: "请输入成本金额",
      trigger: "blur",
    },
    {
      required: true,
      validator: validateDecimal,
      trigger: "blur",
    }
  ],
  realqty: [
  {
      required: true,
      message: "请输入实发数量",
      trigger: "blur",
    },
    { type: 'number', message: '实发数量须是数字',trigger: "blur" },
  ],
  'orderAddress.freightamount': [
    {
      validator: validateDecimal,
      trigger: "blur",
    }
  ],
});

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("orderPath")
  if (query) {
    queryParam.value = query
  }

  currentInstance = getCurrentInstance();

  defaultDate()

  getListOrderIdentifier();
  getListCustomer();
  getListSupplier();
  getListOrder();
  getOrderCounts();
});




const loadingsupplier = ref(false);
const loadingexpress = ref(false)
const exportActionVal = ref('express')

const doExportPageOrder = (type) => {
  let headerTmp = [];

  let header = []

  exportActionVal.value = type


  if (type == 'express') {////按快递单号导出，固定表头
    header = ['0||platformnum||平台订单号', '0||ordernum||垚旌订单号','0||ordertype||订单类型','5||customername||客户', '2||name||商品名称', '2||specification||商品规格', '3||expresscompany||快递公司', '3||expressnum||快递单号'];
    loadingexpress.value = true
  } else if (type == 'supplier') {
    //垚旌订单号	供应商	供应商商品标准名称	供应商商品ID	供应商给垚旌报价	商品数量	收货人姓名	收货人电话	收货地址省	收货地址市	收货地址区	收货地址	客户下单备注 运费金额 后端处理备注 快递公司	快递单号
    header = ['0||ordernum||垚旌订单号','6||suppliername||供应商', '2||name||供应商商品标准名称', '2||specification||商品规格',"2||giftsku||礼包单品SKU编码",'2||barcode||国际条形码', '2||sgoodsnum||供应商商品ID', '1||costamount||供应商给垚旌报价','1||realqty||商品数量','0||receiver||收货人姓名','0||receiverphone||收货人电话','0||receiveraddress||收货地址','0||ordernote||客户下单备注','3||expressdemand||发货快递要求','3||orderidentifier||订单标识','3||abnormalstatus||异常订单状态','3||abnormalnote||异常订单备注','3||note1||商品备注1','3||freightamount||运费金额','3||expresscompany||快递公司', '3||expressnum||快递单号'];//'3||deliverynote||后端处理备注'//发货快递要求、商品备注1
    loadingsupplier.value = true
  }

  header.forEach((item) => {
    let itemTmp = item.split("||");
    headerTmp.push({ index: itemTmp[0], name: itemTmp[1], value: itemTmp[2] });
  });


    //console.log(queryParam.value.customerid)
    let query = JSON.parse(JSON.stringify(queryParam.value)); 
    query.supplierids = query.supplierid?query.supplierid.join(','):''
    query.customerids = query.customerid?query.customerid.join(','):''
    query.pageSize = 10000;

    delete query.customerid
    delete query.supplierid

    let data = {
      order: query,//queryParam.value
      header: headerTmp,
    };

    if (type == "express") {
      exportOrder(data).then((response) => {
        downloadExcel(response);
      });
    } else if (type == "supplier") {//按供应商导出
      exportOrderSupplier(data).then((response) => {
        downloadZip(response);
      });
    }
};

const downloadExcel = (response) => {
  if (exportActionVal.value == 'express') {
    loadingexpress.value = true;
  } else {
    loadingsupplier.value = true;
  }
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      if (exportActionVal.value == 'express') {
        loadingexpress.value = false;
      } else {
        loadingsupplier.value = false;
      }
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    // exportForm.value.header = [];
    // closeDialog();
    // emit("click");
  }, 1000);
};

const downloadZip = (response) => {
  loadingsupplier.value = true;
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingsupplier.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/zip"
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    // exportForm.value.header = [];
    // closeDialog();
    // emit("click");
  }, 1000);
};
</script>
<style scoped>
.waitTab {
  margin-top:15px
}
.waitTab .item {
  margin-right:40px
}
.el-table-fixed-column--right div{
  padding: 0;
}
</style>